module.exports = require("./es-US.js");